import { Navigate, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import Reports from './pages/Reports';
import Support from './pages/Support';
import AdminMessaging from './pages/AdminMessaging'; 
import MessageOversight from './pages/MessageOversight';
import Subjects from './pages/Subjects';
import AdminLad from './pages/AdminLad';
import AdminRecordings from './pages/Recording';
import Announcements from './pages/Announcements';
import MathClasses from './pages/MathClasses';
import MatricClasses from './pages/MatricClasses';
import Reviews from './pages/Reviews';
import Bookings from './pages/Bookings';
import DiscountCodes from './pages/DiscountCodes';
import TutorImports from './pages/TutorImports';
import LessonAlerts from './pages/LessonAlerts';
import BoardLogin from './pages/BoardLogin';
import Workboards, { BoardGuard, BoardPassword, LegacyAdminGuard } from './pages/Workboards';
function App() {
  const legacy = (Component) => <LegacyAdminGuard><Component /></LegacyAdminGuard>;
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/admin" element={legacy(AdminDashboard)} />
      <Route path="/admin/subjects" element={legacy(Subjects)} />
      <Route path="/admin/analytics" element={legacy(AdminLad)} />
      <Route path="/admin/announcements" element={legacy(Announcements)} />
      <Route path="/admin/notifications" element={legacy(Notifications)} />
      <Route path="/admin/reports" element={legacy(Reports)} />
      <Route path="/admin/support" element={legacy(Support)} />
      <Route path="/admin/users" element={legacy(Users)} />
      <Route path="/admin/bookings" element={legacy(Bookings)} />
      <Route path="/admin/discount-codes" element={legacy(DiscountCodes)} />
      <Route path="/admin/lesson-alerts" element={legacy(LessonAlerts)} />
      <Route path="/admin/tutor-imports" element={legacy(TutorImports)} />
      <Route path="/admin/reviews" element={legacy(Reviews)} />
      <Route path="/admin/math-classes" element={legacy(MathClasses)} />
      <Route path="/admin/matric-classes" element={legacy(MatricClasses)} />
      <Route path="/admin/settings" element={legacy(Settings)} />
      <Route path="/admin/messages" element={legacy(AdminMessaging)} />
      <Route path="/admin/message-oversight" element={legacy(MessageOversight)} />
      <Route path="/admin/recordings" element={legacy(AdminRecordings)} />
      <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
      <Route path="/boards/login" element={<BoardLogin />} />
      <Route path="/boards/change-password" element={<BoardGuard><BoardPassword /></BoardGuard>} />
      <Route path="/boards/:board" element={<BoardGuard><Workboards /></BoardGuard>} />
    </Routes>
  );
}

export default App;











